import { render } from "./PackageTable.vue?vue&type=template&id=2e2a8538"
import script from "./PackageTable.vue?vue&type=script&lang=js"
export * from "./PackageTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__